// 「代導演」：專案的製作（PM、副手、全站製作）替導演寫留言、按通過 / 需修改時可以標一下，
// 動畫師才分得清這是導演要改的；導演也會收到通知。這只是標示，權限完全不變（後台 cf-worker/reviews.mjs 擋，這裡只決定畫面上顯示什麼）。
// 純函式（commentAuthor.test.ts 有測）：作者那一行、匯出、審片紀錄、提示文字都從這裡拿，所有地方才會一致。

import type { ProjectRole } from '../mockData';

/** 小標籤 / 勾選框上的字 */
export const ON_BEHALF_LABEL = '代導演';
/** 勾選框旁邊的小字 */
export const ON_BEHALF_HINT = '這是導演的意見，我幫他記下來';

/** 這個人看得到「代導演」勾選嗎：專案的製作、副手、全站製作（跟後台 canEditProjectContent 一樣）；導演、動畫師、訪客沒有 */
export function canMarkOnBehalf(projectRole: ProjectRole | string | null | undefined): boolean {
  return projectRole === 'admin';
}

/** 留言的作者文字（純文字用：匯出、提示、搜尋）：「阿宏（代導演）」；一般留言就是名字 */
export function commentAuthorText(c: { author: string; onBehalfOfDirector?: boolean }): string {
  return c.onBehalfOfDirector ? `${c.author}（${ON_BEHALF_LABEL}）` : c.author;
}

/** 審片紀錄裡「誰按的」：「製作 阿宏（代導演）」；一般的就是「製作 阿宏」 */
export function reviewerWithBehalf(who: string, onBehalf: boolean | undefined): string {
  return onBehalf && who ? `${who}（${ON_BEHALF_LABEL}）` : who;
}
